import React from "react";
import * as S from "./styles";
import { getAvatarColor, getInitials, isImageUrl } from "../../utils/user";

interface IUserAvatar {
  name?: string;
  code?: number;
  avatar?: string; // foto (futuro); sem foto mostra as iniciais
  size?: number;
  light?: boolean; // versão clara, para fundos coloridos
}

const UserAvatar: React.FC<IUserAvatar> = ({
  name,
  code,
  avatar,
  size = 44,
  light = false,
}) => {
  const [imageFailed, setImageFailed] = React.useState(false);
  const showImage = isImageUrl(avatar) && !imageFailed;

  return (
    <S.Circle
      $size={size}
      $color={light ? "rgba(255, 255, 255, 0.22)" : getAvatarColor(code ?? name)}
      aria-hidden
    >
      {showImage ? (
        <S.Photo src={avatar} alt="" onError={() => setImageFailed(true)} />
      ) : (
        getInitials(name)
      )}
    </S.Circle>
  );
};

export default UserAvatar;
